import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import {
  postNotificationDestinations,
  PostNotificationDestinationsRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useCreateNotificationDestinationsMutation = () => {
  return useMutation({
    mutationFn: postNotificationDestinations,
    onError(error: BaseErrorResponse, data: PostNotificationDestinationsRequest) {
      logSentryError('Error from useCreateWebhookDestinationsMutation', error, data)
    },
  })
}
